const ContactFields = ({
  formDataUser,
  handleChange,
  mode,
  loading,
  editable,
}) => {
  return (
    <>
      <div>
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
          Email<span className="text-red-700"> *</span>
        </label>
        <input
          type="email"
          name="email"
          value={formDataUser.email}
          onChange={handleChange}
          disabled={mode !== 'create' || loading || !editable}
          className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
          required
          readOnly
          onFocus={(e) => (e.target.readOnly = false)}
        />
      </div>
      <div>
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
          Email alternativo
        </label>
        <input
          type="email"
          name="alternativeEmail"
          value={formDataUser.alternativeEmail}
          onChange={handleChange}
          disabled={!editable}
          className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
        />
      </div>
      <div>
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
          Teléfono celular<span className="text-red-700"> *</span>
        </label>
        <input
          type="tel"
          name="cellPhone"
          value={formDataUser.cellPhone}
          onChange={handleChange}
          disabled={!editable}
          className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
          required
        />
      </div>
      <div>
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
          Teléfono fijo
        </label>
        <input
          type="tel"
          name="phone"
          value={formDataUser.phone}
          onChange={handleChange}
          disabled={!editable}
          className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
        />
      </div>
    </>
  );
};

export default ContactFields;
